import VolumeUpRoundedIcon from "@mui/icons-material/VolumeUpRounded";
import { SOUND_CATEGORIES, soundCatalog, getSoundSource, resolveSoundId } from "../sounds/catalog";
import { playSound, unlockAudio } from "../utils/audio";
export default function SoundSettings({ selections, onChange, enabled, children }) {
  return <section className="settings-group">
    <h3>Sounds</h3>
    {children}
    {SOUND_CATEGORIES.map(({ id, label, description }) => <div className="settings-row sound-settings-row" key={id}>
      <label className="settings-row-copy" htmlFor={`sound-${id}`}><strong>{label}</strong><small id={`sound-description-${id}`}>{description}</small></label>
      <div className="sound-settings-controls">
        <select id={`sound-${id}`} aria-label={label} aria-describedby={`sound-description-${id}`} value={resolveSoundId(id, selections[id])} onChange={(event) => onChange(id, event.target.value)}>
          {soundCatalog[id].map((sound) => <option key={sound.id} value={sound.id}>{sound.label}</option>)}
        </select>
        <button type="button" disabled={!enabled} aria-label={`Preview ${label.toLowerCase()}`}
          title={enabled ? "Preview sound" : "Enable Sound alerts to preview"}
          onClick={() => { unlockAudio(); playSound(getSoundSource(id, selections[id])); }}><VolumeUpRoundedIcon fontSize="small" /></button>
      </div>
    </div>)}
  </section>;
}
